import { OverrideWacFormState } from '../index'

export default function validateForm( formState: OverrideWacFormState ): { isInvalid: boolean, newFormState: OverrideWacFormState } {
	const newFormState = {
		...formState,
	}
	let isInvalid = false

	if ( formState.wac === '' || isNaN( parseFloat( formState.wac ) ) ) {
		isInvalid = true
		newFormState.validation.wac = {
			isInvalid: true,
			error: 'WAC is required',
		}
	} else {
		newFormState.validation.wac = { isInvalid: false }
	}

	if ( !formState.date || formState.validation.date.isInvalid ) {
		isInvalid = true
		newFormState.validation.date = {
			isInvalid: true,
			error: !formState.date ? 'Date is required' : 'Selected date is in the future',
		}
	} else {
		newFormState.validation.date = { isInvalid: false }
	}

	if ( formState.reason === '' ) {
		isInvalid = true
		newFormState.validation.reason = {
			isInvalid: true,
			error: 'You must provide a reason',
		}
	} else {
		newFormState.validation.reason = { isInvalid: false }
	}

	return {
		isInvalid,
		newFormState,
	}
}
